export default "__VITE_ASSET__CUFtf$xM__"